const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/metaKat.ts';
import { useRemoteData } from '@cistec/common_web/hooks/useRemoteData';
import {
    multiMetaKatKeys,
    multiMetaKatKeysRequestStatus,
    multiMetaKatRecords,
    multiMetaKatRecordsCount,
} from '@cistec/common_web/selectors/metakatSelectors';
import { loadMultiMetaKatRecords } from 'App/actions/metakat';
import { createSelector } from 'reselect';
import { PatAppStoreState } from 'App/store/setup/rootReducer';
import { MetaKatItem } from '@cistec/common_web/defs/kisim';
import { RequestStatus } from '@cistec/common_web/utils/redux4Requests';

export interface Country {
    ICODE: string;
    PCODE: string;
    FKEY: string;
    NAME: string;
    POS: string;
    CONTENT: {
        English: string;
    };
    isFav: boolean;
}

// SELECTORS

export const selectCountries = createSelector(
    [multiMetaKatKeys, multiMetaKatRecords],
    (multiMetaKatKeys, multiMetaKatRecords): MetaKatItem[] => {
        const countries = multiMetaKatRecords?.get(multiMetaKatKeys['Countries'])?.toJS();
        return Object.values(countries);
    }
);

export const selectRelationTypes = createSelector(
    [multiMetaKatKeys, multiMetaKatRecords],
    (multiMetaKatKeys, multiMetaKatRecords): MetaKatItem[] => {
        const relativeTypes = multiMetaKatRecords?.get(multiMetaKatKeys['Beziehung'])?.toJS();
        if (!relativeTypes) {
            return [];
        }
        return Object.values(relativeTypes);
    }
);

// HOOKS

export function useMetaKatListData() {
    // we should not massload stuff.. it makes it impossible to track where what data/metakat is used...
    return useRemoteData({}, () => ({
        // FIXME: W T F (this was selectIsLoadingExternalLinks)
        // As a bit less W T F (but still temporary solution), isLoading is considered true if there is no data
        isLoading: (state: PatAppStoreState) => {
            return !multiMetaKatRecordsCount(state);
        },
        select: multiMetaKatRecordsCount,
        shouldFetch: (state: PatAppStoreState) => {
            const multiMetaKeys = Object.values(multiMetaKatKeys(state));
            const requestStatus = multiMetaKatKeysRequestStatus(state);

            return (
                (requestStatus === RequestStatus.PENDING || requestStatus === RequestStatus.SUCCESS) &&
                multiMetaKeys.length > 0 &&
                !multiMetaKatRecordsCount(state) &&
                !state.metakat.getIn(['loading', 'multiMetaKat'])
            );
        },
        fetch: (dispatch, state) => {
            const multiMetaKeys = multiMetaKatKeys(state);
            dispatch(loadMultiMetaKatRecords(Object.values(multiMetaKeys)));
        },
    }));
}
